//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

export default {
    components: {
        PageHeader: () => import('~/components/page/header.vue'),
        UiTagline: () => import('~/components/ui/tagline.vue'),
    },
    scrollToTop: true,
    head() {
        return {
            meta: [
                {
                    hid: 'og:title',
                    name: 'og:title',
                    content: this.$t('title'),
                },
            ],
            title: this.$t('title'),
        };
    },
    computed: {
        ...mapState('cases', ['cases']),
    },
};
